module.exports = __webpack_public_path__ + "assets/images/puzzle-collection_1d51fa68d9844ecdcd680e50d0606dd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/intro/puzzle-collection.png
// module id = 286
// module chunks = 0